module.exports = __webpack_public_path__ + "img/bg-fr-mb.06ea65c3.webp";